import { render, staticRenderFns } from "./DocUploadPop.vue?vue&type=template&id=277c2126"
import script from "./DocUploadPop.vue?vue&type=script&lang=js"
export * from "./DocUploadPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('277c2126')) {
      api.createRecord('277c2126', component.options)
    } else {
      api.reload('277c2126', component.options)
    }
    module.hot.accept("./DocUploadPop.vue?vue&type=template&id=277c2126", function () {
      api.rerender('277c2126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/DocUploadPop.vue"
export default component.exports